import { useForm, useFormContext, useWatch } from 'react-hook-form';

import portalSchema from 'support/types/schema-portal';

import { getUnmatchedArticleLineItemIndex } from './findUnmatchedArticleAnnotations';

type Annotation = portalSchema.components['schemas']['Annotation'];
type UnmatchedArticleAnnotationValue = portalSchema.components['schemas']['UnmatchedArticleAnnotationValue'];

export type UnmatchedArticleDisplayData = {
  name: string;
  gtin: string | null;
};

type WatchedLineItem = {
  item?: { name?: string; identifiers?: { gtin?: string | null } };
};

export const useUnmatchedArticleDisplayData = (annotation: Annotation): UnmatchedArticleDisplayData => {
  const formContext = useFormContext<Record<string, unknown>>();
  const fallbackForm = useForm<Record<string, unknown>>({ defaultValues: {} });
  const activeControl = formContext?.control ?? fallbackForm.control;
  const watchedLineItems = useWatch({ control: activeControl, name: 'line_items' }) as
    | Array<WatchedLineItem>
    | undefined;

  const rawValue = annotation.value.current_value;
  const value: UnmatchedArticleAnnotationValue =
    rawValue && typeof rawValue === 'object' ? (rawValue as UnmatchedArticleAnnotationValue) : { identifiers: {} };

  let name = typeof value.name === 'string' ? value.name : '';
  let gtin = typeof value.identifiers.gtin === 'string' ? value.identifiers.gtin : null;

  const lineItemIndex = getUnmatchedArticleLineItemIndex(annotation.path);
  if (Array.isArray(watchedLineItems) && lineItemIndex !== null) {
    const matchedItem = watchedLineItems[lineItemIndex];
    if (matchedItem?.item) {
      if (typeof matchedItem.item.name === 'string') {
        name = matchedItem.item.name;
      }
      if (typeof matchedItem.item.identifiers?.gtin === 'string') {
        gtin = matchedItem.item.identifiers.gtin;
      }
    }
  }

  return { name, gtin };
};
